export default {
  calendarVisible: false,
  calendarEvents: [],
  statuses: []
}
